import axios from "axios";

import { IIntervalsFactResponse, IIntervalsPlanResponse, IIntervalsRequest } from "./types";

export const intervalsApi = {
  getIntervals: ({ buildingId, sectionId, start_at, end_at, all, structure = "sections" }: IIntervalsRequest) => {
    return axios.get<IIntervalsPlanResponse | IIntervalsFactResponse>(
      `/building/${buildingId}/estimate/plan/${structure}/${sectionId}/week/`,
      {
        params: { start_at, end_at, all },
      }
    );
  },
};
